<div class="tab-content">
  <div class="form-group" [formGroup]="form">
    <!-- TECHNICAL STATE -->
    <div style="display: flex">
      <div class="form-field" style="flex: 1" [class.missing-data]="isFieldMissing('etat_technique')">
        <label for="etat_technique">{{ "asset_form_drawer.synthese.technical_state" | translate }}</label>
        <nb-select id="etat_technique" formControlName="etat_technique" fullWidth (selectedChange)="onTechnicalStateChange($event)" [placeholder]="currentNote !== null && currentNote !== undefined ? '' : '-'">
          @for (option of technicalStateOptions; track option.value) {
          <nb-option [value]="option.label">{{ option.label }}</nb-option>
          }
        </nb-select>
      </div>
      @if ((technicalStatusEvaluatedBy || technicalStatusEvaluationDate) && (currentNote !== null && currentNote !== undefined)) {
      <div style="flex: 1" class="form-field evaluated-by-container">
        <p class="evaluated-by-text author-date">
          {{ getEvaluatedByText() }}
        </p>
      </div>
      }
    </div>
    @if (currentNote !== null && currentNote !== undefined) {
    <div style="display: flex">
      <div class="form-field" style="flex: 1" [class.missing-data]="isFieldMissing('motif_evaluation')">
        <label for="motif_evaluation">{{ "asset_form_drawer.synthese.rating_reason" | translate }}</label>
        @if (!updatingRatingReasons && ratingReasonsForState.length > 0) {
        <nb-select
          #motifEvaluationSelect
          id="motif_evaluation"
          formControlName="motif_evaluation"
          fullWidth
          multiple="true"
          placeholder="{{ 'Click here (obligatory info)' | translate }}"
          (selectedChange)="ratingReasonUpdated($event)"
        >
          @for (reason of ratingReasonsForState; track reason.id) {
          <nb-option [value]="reason.id">
            {{ reason.name }}
          </nb-option>
          }
        </nb-select>
        } @else {
        <input nbInput id="motif_evaluation" type="text" formControlName="motif_evaluation" fullWidth readonly />
        }
      </div>
      <div class="form-field" style="flex: 1"></div>
    </div>
    } @else {
    <div class="form-field" [class.missing-data]="isFieldMissing('motif_absence_evaluation')">
      <label for="motif_absence_evaluation">{{ "asset_form_drawer.synthese.reason_for_impossibility_of_evaluation" | translate }}</label>
      <nb-select #motifAbsenceEvaluationSelect id="motif_absence_evaluation" formControlName="motif_absence_evaluation" fullWidth placeholder="-" (selectedChange)="onMissingNotationReasonChanged()">
        @for (reason of missingNotationReasons; track reason.value) {
        <nb-option [value]="reason.value">{{ reason.name }}</nb-option>
        }
      </nb-select>
    </div>
    }

    <div style="display: flex">
      <div class="form-field" style="flex: 1">
        <label for="installation_year">{{ "pages.insight.asset.installation_year" | translate }}</label>
        <input
          nbInput
          id="installation_year"
          type="number"
          formControlName="installation_year"
          fullWidth
          placeholder="0"
          (blur)="installationYearUpdated()"
        />
      </div>
      @if (form.get('installation_year')?.value) {
      <div style="flex: 1" class="form-field evaluated-by-container">
        <p class="evaluated-by-text">
          {{ "Current age" | translate }} : {{ currentYear - form.get('installation_year').value }} {{ (currentYear - form.get('installation_year').value) === 1 ? ("year" | translate) : ("years" | translate) }}
        </p>
      </div>
      }
    </div>

    @if (currentNote !== null && currentNote !== undefined) {
    <div style="display: flex">
      <div class="form-field" style="flex: 1">
      <label for="nb_annees_restantes">{{ "asset_form_drawer.synthese.remaining_years" | translate }}</label>
        <input nbInput id="nb_annees_restantes" type="number" formControlName="nb_annees_restantes" fullWidth [readonly]="false" [min]="0" [max]="asset?.asset_type_object?.expected_duration" (blur)="remainingLifetimeUpdated()" />
      </div>
      <div style="flex: 1" class="form-field evaluated-by-container">
        <p class="evaluated-by-text">
          <span>{{ getSourceLabel() }} :</span>
          <span class="source-value">{{ getSourceValue() }}</span>
        </p>
      </div>
    </div>
    }

    @if (plannedEndOfLifeYear !== null) {
    <div style="display: flex">
      <div class="form-field" style="flex: 1">
        <label>{{ "asset_form_drawer.synthese.planned_end_of_life" | translate }}</label>
        <input nbInput type="number" [value]="plannedEndOfLifeYear" fullWidth readonly />
      </div>
      <div style="flex: 1" class="form-field evaluated-by-container">
        <div class="planned-lifetime-row">
          <p class="evaluated-by-text">
            {{ "asset_form_drawer.synthese.planned_lifetime_years" | translate: { years: plannedLifetimeYears } }}
          </p>
          @if (isLifetimeBelowThreshold()) {
          <i
            class="fa-light fa-triangle-exclamation lifetime-warning-icon"
            [title]="'asset_form_drawer.synthese.consistency_check_title' | translate"
            (click)="openLifetimeConsistencyModal()"
          ></i>
          }
        </div>
      </div>
    </div>
    }

    <!-- REFERENCE LIFETIME AND INIIES SHEET -->
    <div style="display: flex">
      <div class="form-field" style="flex: 1" [class.missing-data]="isFieldMissing('duree_vie_reference')">
        <label for="duree_vie_reference">
          {{ "asset_form_drawer.synthese.reference_lifetime" | translate }}
        </label>
        <input
          nbInput
          id="duree_vie_reference"
          type="number"
          formControlName="duree_vie_reference"
          fullWidth
          readonly
        />
      </div>
      @if ((form.get('fiche_iniies')?.value ?? 0) > 0) {
      <div class="form-field" style="flex: 1">
        <label for="fiche_iniies">{{ "asset_form_drawer.synthese.iniies_sheet" | translate }}</label>
        <div class="inies-sheet-row">
          <input nbInput id="fiche_iniies" type="number" formControlName="fiche_iniies" readonly />
          @if (showIniesDataSheet) {
          <div class="inies-copy-btn" (click)="openIniesModal()">
            <img src="assets/icons/copy.svg" alt="Copy" class="copy-icon">
          </div>
          }
        </div>
      </div>
      }
    </div>

    <!-- MAINTENANCE QUALITY EVALUATION -->
    @if (maintenanceManagementEnabled) {
    <div style="display: flex">
      <div class="form-field" style="flex: 1">
        <label for="maintenance_evaluation">{{ "asset_form_drawer.synthese.maintenance_evaluation" | translate }}</label>
        <nb-select
          id="maintenance_evaluation"
          formControlName="maintenance_evaluation"
          fullWidth
          placeholder="-"
        >
          <nb-option value="">-</nb-option>
          <nb-option value="satisfactory">{{ "asset_form_drawer.options.satisfactory" | translate }}</nb-option>
          <nb-option value="unsatisfactory">{{ "asset_form_drawer.options.unsatisfactory" | translate }}</nb-option>
        </nb-select>
      </div>
      @if ((maintenanceEvaluatedBy || maintenanceEvaluationDate) && maintenanceEvaluation) {
      <div style="flex: 1" class="form-field evaluated-by-container">
        <p class="evaluated-by-text author-date">
          {{ getMaintenanceEvaluatedByText() }}
        </p>
      </div>
      }
    </div>
    }
  </div>
</div>

<!-- INIIES Modal -->
@if (showIniesModal) {
<div class="drawer">
  <div class="drawer__backdrop" (click)="closeIniesModal()"></div>
  <div class="drawer__panel">
    <!-- HEADER -->
    <div class="drawer__header">
      <div class="title">{{ "asset_form_drawer.synthese.environmental_data_sheets" | translate }}</div>
      <!-- Icons after title -->
      <div class="icons-container">
        <span class="close-btn" (click)="closeIniesModal()">
          <i class="fa-light fa-x"></i>
        </span>
      </div>
    </div>

    <!-- CONTENT -->
    <div class="drawer__content">
      <div class="inies-content">
        <div *ngFor="let url of iniesDataSheets; let i = index" class="inies-url-item">
          <div class="inies-url-info">
            <div class="inies-url" rel="noopener noreferrer">{{ url }}</div>
          </div>
          <div class="inies-copy-btn" (click)="openUrlInNewTab(url, $event)">
            <img src="assets/icons/copy.svg" alt="Copy" class="copy-icon-detail">
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
}
